export function getNulls(...args: any) {
    return [args].filter(x => x === null);
}

export function upperCaseFirstLetter(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}
